<p-dialog header="Данные клиента" [(visible)]="visible" [modal]="true" [maximizable]="true" (onHide)="closeDialog()"
[style]="{width: '500px'}">
    <div class="card p-fluid">

        <form [formGroup]="registerForm" (ngSubmit)="saveClientForm()" autocomplete="off">

            <div class="">
                <input type="hidden" formControlName="id"/>
                <input type="hidden" formControlName="client_id"/>

                <div class="field">
                    <label for="first_name">Имя</label>
                    <input type="text" pInputText formControlName="first_name" id="first_name">

                    @if(!registerForm.get('first_name')?.valid && registerForm.get('first_name')?.touched){
                    <small class="error_message">
                        Укажите имя клиента (минимум 2 символа)
                    </small>
                    }
                </div>

                <div class="field">
                    <label for="last_name">Фамилия</label>
                    <input type="text" pInputText formControlName="last_name" id="last_name">

                    @if(!registerForm.get('last_name')?.valid && registerForm.get('last_name')?.touched){
                    <small class="error_message">
                        Укажите фамилию клиента (минимум 2 символа)
                    </small>
                    }

                </div>

                <div class="field">
                    <label for="login">Логин для входа</label>
                    <input type="text" pInputText formControlName="login" id="login">

                    @if(registerForm.get('login')?.errors && registerForm.get('login')?.touched){
                    <small class="error_message">

                        <!-- <div *ngIf="checkIf(registerForm)"></div> -->
                        @if(registerForm.get('login')?.hasError('loginAlreadyExist')) {
                        Пользователь с таким логином уже зарегистрирован
                        } @else {
                        Укажите логин для входа (минимум 3 символа)
                        }
                    </small>
                    }
                </div>

                <div class="field">
                    <label for="phone">Номер телефона</label>
                    <input pInputText placeholder="Номер телефона" formControlName="phone" id="phone">

                    @if(!registerForm.get('phone')?.valid && registerForm.get('phone')?.touched) {
                    <small class="error_message">
                        Введите номер телефона в формате +XXX (XXX) XХХ-ХХХХ
                    </small>
                    }
                </div>

                <div class="field">
                    <label for="client_code">Код пользователя</label>
                    <input type="text" pInputText formControlName="client_code" id="client_code">

                    @if(registerForm.get('client_code')?.errors && registerForm.get('client_code')?.touched) {
                    <small class="error_message">
                        @if(registerForm.get('client_code')?.hasError('userAlreadyExist')) {
                        Данный код уже используется. Обратитесь к представителю карго.
                        } @else {
                        Код пользователя должен быть более 3х символов
                        }
                    </small>
                    }
                </div>

                <div class="field">
                    <label for="client_city">Город</label>
                    <input type="text" pInputText formControlName="client_city" id="client_city">

                    <p class="form-text text-muted"
                        *ngIf="!registerForm.get('client_city')?.valid && registerForm.get('client_city')?.touched">
                        Пожалуйста укажите город
                    </p>
                </div>

                <div class="field">
                    <label for="email">Email</label>
                    <input type="text" pInputText formControlName="email" id="email">

                    @if(registerForm.get('email')?.errors && registerForm.get('email')?.touched) {
                    <small class="error_message">
                        @if(registerForm.get('email')?.hasError('emailAlreadyExist')) {
                        Пользователь с таким email уже зарегистрирован
                        } @else {
                        Неправильный формат email адреса
                        }
                    </small>
                    }
                </div>

            </div>

            <div class="flex justify-end flex-wrap mt-6">
                <p-button type="submit" label="{{editMode ? 'Сохранить' : 'Регистрация'}}" icon="pi pi-user-plus"
                    [style]="{width: '150px'}">
                </p-button>
            </div>
        </form>
    </div>
</p-dialog>